import React, {
  FunctionComponent,
  useCallback,
  useMemo,
  useState,
} from "react";
import CurrencyContext from "contexts/CurrencyContext";
import { Currency } from "types";
import { defaultCurrency } from "config";

type CurrencyProviderProps = {};

const CurrencyProvider: FunctionComponent<CurrencyProviderProps> = ({
  children,
}) => {
  const [currency, setCurrency] = useState<Currency>(
    (localStorage.getItem("lastCurrency") as Currency) || defaultCurrency
  );

  const changeCurrency = useCallback((currency: Currency) => {
    localStorage.setItem("lastCurrency", currency);
    setCurrency(currency);
  }, []);

  const contextValue = useMemo(
    () => ({
      currency,
      changeCurrency,
    }),
    [currency, changeCurrency]
  );

  return (
    <CurrencyContext.Provider value={contextValue}>
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
